/**
 * @lodex-pro/shared/audit/job-site-change-events — #60 / DEC-365.
 *
 * The audit events a pickup-site change writes, and the words the dispatcher timeline shows
 * for each. One list for the same reason as job-creation-events.ts: the job audit endpoint
 * (`routes/jobs/audit.ts`) admits exactly this set, and the timeline renders these labels.
 */

export const JOB_SITE_CHANGE_EVENT_LABELS = {
  /** The site changed (office route, or a driver's change applied from sync). */
  JOB_SITE_CHANGED: 'Site changed',
  /** A driver's change could not be applied and waits on the Sync page. */
  JOB_SITE_CHANGE_PARKED: "Driver's site change sent for review",
  /** The office applied a parked driver change. */
  JOB_SITE_CHANGE_APPLIED: "Driver's site change applied",
  /** The office picked a tank for a captured tank row (after a site change unlinked it). */
  HAULER_TANK_RELINKED: 'Tank re-linked',
} as const satisfies Record<string, string>;

export type JobSiteChangeEventType = keyof typeof JOB_SITE_CHANGE_EVENT_LABELS;

export const JOB_SITE_CHANGE_EVENT_TYPES = Object.keys(
  JOB_SITE_CHANGE_EVENT_LABELS,
) as readonly JobSiteChangeEventType[];

/** Where a change came from — the audit payload's `source`. */
export type JobSiteChangeSource = 'DRIVER_APP' | 'DISPATCH_WEB' | 'IN_REVIEW';
